module.exports = __webpack_public_path__ + "static/media/Streetballcourt_main_t.cc3af858.jpg";